import { ENUM_DEFAUT_VTECH } from './ModbusXRayGeneratorController';

const EXAMION_ERROR_CODE_OFFSET = 0x80;
const EXAMION_WARNING_CODE_OFFSET = 0x10;

export function convertErrorCodeToExamionCode(vTechErrorCode: number, isError: boolean) {
  switch (vTechErrorCode) {
    case ENUM_DEFAUT_VTECH.DEPASSEMENT_KV:
    case ENUM_DEFAUT_VTECH.DISSYMETRIE:
    case ENUM_DEFAUT_VTECH.EXPO_TROP_LONG:
    case ENUM_DEFAUT_VTECH.MONTEE_KV_TROP_LENT:
    case ENUM_DEFAUT_VTECH.ECART_MA_50:
    case ENUM_DEFAUT_VTECH.MONTEE_KV_TROP_RAPIDE:
    case ENUM_DEFAUT_VTECH.DEFAUT_STATOR_ALIMENTE_SANS_ORDRE:
    case ENUM_DEFAUT_VTECH.DEFAUT_TIR_INTERDIT:
    case ENUM_DEFAUT_VTECH.ICF_INCORRECT_STBY:
    case ENUM_DEFAUT_VTECH.ICF_TROP_FAIBLE_TIR:
    case ENUM_DEFAUT_VTECH.DEPASSE_TEMP_TUBE:
    case ENUM_DEFAUT_VTECH.DEFAUT_CHARGE_CAPA:
    case ENUM_DEFAUT_VTECH.DEFAUT_IDENTICATION_LOGICIEL_PC:
    case ENUM_DEFAUT_VTECH.DEFAUT_INTER_TIR:
    case ENUM_DEFAUT_VTECH.ATTENTE_CHARGE_CONDO:
    case ENUM_DEFAUT_VTECH.ANNULATION_TIR:
    case ENUM_DEFAUT_VTECH.ECART_MA_20:
    case ENUM_DEFAUT_VTECH.TMPS_PREPA:
    case ENUM_DEFAUT_VTECH.PAS_DONNEE_TIR:
    case ENUM_DEFAUT_VTECH.IA_TROP_FORT:
    case ENUM_DEFAUT_VTECH.COURANT_STATOR_TROP_FAIBLE:
    case ENUM_DEFAUT_VTECH.COURANT_STATOR_TROP_FORT:
    case ENUM_DEFAUT_VTECH.COMM_AVEC_SECU:
    case ENUM_DEFAUT_VTECH.COMM_AVEC_MEM:
    case ENUM_DEFAUT_VTECH.PAS_DE_KV:
    case ENUM_DEFAUT_VTECH.ICF_TROP_FORT_TIR:
    case ENUM_DEFAUT_VTECH.WATCHDOG_SECU:
    case ENUM_DEFAUT_VTECH.ERREUR_CONNECTIQUE:
    case ENUM_DEFAUT_VTECH.WATCHDOG_COMMANDE:
    case ENUM_DEFAUT_VTECH.ERREUR_COMMUNICATION_GENERATEUR:
    default:
      return isError
        ? { errorCode: EXAMION_ERROR_CODE_OFFSET + vTechErrorCode }
        : { warningCode: EXAMION_WARNING_CODE_OFFSET + vTechErrorCode };
  }
}

export function convertExamionCodeToGER(examionCode: number) {
  if (examionCode >= EXAMION_ERROR_CODE_OFFSET) {
    return { code: examionCode - EXAMION_ERROR_CODE_OFFSET, isError: true };
  } else if (examionCode >= EXAMION_WARNING_CODE_OFFSET) {
    return { code: examionCode - EXAMION_WARNING_CODE_OFFSET, isWarning: true };
  }
  return { code: examionCode, isUnknown: true };
}
